import { Sort } from "@css/icons/SVG"
import { Dropdown } from "antd"
import React, { useCallback, useMemo, useRef } from "react"
import styles from "@css/modules/Listings.module.scss"

const predefinedFilters = [
    {
        text: () => (
            <>
                <strong>Deal Score:</strong> Low to High
            </>
        ),
        direction: "ascend",
        key: "stars"
    },
    {
        text: () => (
            <>
                <strong>Deal Score:</strong> High to Low
            </>
        ),
        direction: "descend",
        key: "stars"
    },
    {
        text: () => (
            <>
                <strong>Resorts:</strong> A-Z
            </>
        ),
        direction: "ascend",
        key: "resort.short_name"
    },
    {
        text: () => (
            <>
                <strong>Resorts:</strong> Z-A
            </>
        ),
        direction: "descend",
        key: "resort.short_name"
    },
    {
        text: () => (
            <>
                <strong>Price:</strong> Low to High
            </>
        ),
        direction: "ascend",
        key: "price"
    },
    {
        text: () => (
            <>
                <strong>Price:</strong> High to Low
            </>
        ),
        direction: "descend",
        key: "price"
    },
    {
        text: () => (
            <>
                <strong>Age:</strong> Oldest to Newest
            </>
        ),
        direction: "ascend",
        key: "parsed_date"
    },
    {
        text: () => (
            <>
                <strong>Age:</strong> Newest to Oldest
            </>
        ),
        direction: "descend",
        key: "parsed_date"
    },
    {
        text: () => (
            <>
                <strong>Price per point:</strong> Low to High
            </>
        ),
        direction: "ascend",
        key: "price_per_point"
    },
    {
        text: () => (
            <>
                <strong>Price per point:</strong> High to Low
            </>
        ),
        direction: "descend",
        key: "price_per_point"
    },
    {
        text: () => (
            <>
                <strong>Points on contract:</strong> Low to High
            </>
        ),
        direction: "ascend",
        key: "points_on_contract"
    },
    {
        text: () => (
            <>
                <strong>Points on contract:</strong> High to Low
            </>
        ),
        direction: "descend",
        key: "points_on_contract"
    },
    {
        text: () => (
            <>
                <strong>Current year points:</strong> Low to High
            </>
        ),
        direction: "ascend",
        key: "current_year_points"
    },
    {
        text: () => (
            <>
                <strong>Current year points:</strong> High to Low
            </>
        ),
        direction: "descend",
        key: "current_year_points"
    }
]

export function SortBtn({ placement = "topCenter", onChange, sort = {}, text = "", resortSorting }) {
    const containerRef = useRef(null)

    const handleMenuClick = useCallback(
        (e) => {
            const [columnKey, order] = e.key.split(":")
            onChange({ columnKey, order })
        },
        [onChange]
    )

    const selected = `${sort.column}:${sort.order}`
    const menuProps = useMemo(
        () => ({
            className: styles.sortingMenu,
            onClick: handleMenuClick,
            items: predefinedFilters
                .filter((i) => (resortSorting ? i.key !== "resort.short_name" : true))
                .map((i) => {
                    const key = i.key + ":" + i.direction
                    const className = selected === key ? styles.sortingMenuSelected : undefined
                    return {
                        label: i.text(),
                        className,
                        key: i.key + ":" + i.direction
                    }
                })
        }),
        [selected, handleMenuClick, resortSorting]
    )
    return (
        <div ref={containerRef} className={styles.sortingContainer}>
            <Dropdown menu={menuProps} trigger={["click"]} placement={placement} getPopupContainer={() => containerRef.current} arrow overlayClassName={styles.sortingMenuOverlay}>
                <button className={styles.sortingBtn} aria-label="sort">
                    {text}
                    <Sort className={styles.sortIcon} />
                </button>
            </Dropdown>
        </div>
    )
}
